import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import api from "../api"; // Uncomment when using real API

const ActivityCard = ({ userId, startDateTime, endDateTime }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const COLORS = [
    "#3194ffff", "#3dcd2aff", "#f28e2c", "#edc949",
    "#9c755f", "#76b7b2", "#e15759", "#b07aa1",
    "#ff9da7", "#bab0ac"
  ];

  useEffect(() => {
    const fetchClicks = async () => {
      try {
        const response = await api.get("/clicks/hours", {
          params: {
            user_id: userId,
            start_date: startDateTime,
            end_date: endDateTime,
          },
        });

        const rawData = response.data.data;

        // Aggregate clicks per hour across all dates per event
        const eventClicksByHour = {};
        Object.values(rawData).forEach(({ event_name, clicks_hours }) => {
          if (!eventClicksByHour[event_name]) {
            eventClicksByHour[event_name] = {};
          }
          for (const date in clicks_hours) {
            const hourlyClicks = clicks_hours[date];
            for (const hourStr in hourlyClicks) {
              const hour = parseInt(hourStr, 10);
              eventClicksByHour[event_name][hour] =
                (eventClicksByHour[event_name][hour] || 0) + hourlyClicks[hourStr];
            }
          }
        });

        // Get current hour and build last 24 hours starting from currentHour - 1
        const now = new Date();
        const currentHour = now.getHours();
        const hours = Array.from({ length: 24 }, (_, i) => (currentHour - i + 24) % 24).reverse();

        // Build chart data: each object has hour and clicks per event
        const chartData = hours.map((hour) => {
          const row = { hour };
          for (const eventName in eventClicksByHour) {
            row[eventName] = eventClicksByHour[eventName][hour] || 0;
          }
          return row;
        });

        setData(chartData);
      } catch (err) {
        console.error("Failed to fetch activity data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClicks();
  }, [userId, startDateTime, endDateTime]);

  return (
    <Card className="shadow mb-4">
      <Card.Body>
        <Card.Title className="fw-bold">Activity</Card.Title>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="hour"
                tickFormatter={(hour) => `${hour}h`}
                label={{ value: "Hour", position: "insideBottom", offset: -5 }}
              />
              <YAxis
                label={{ value: "Visits", angle: -90, position: "insideLeft" }}
              />
              <Tooltip />
              <Legend />
              {Object.keys(data[0] || {})
                .filter((key) => key !== "hour")
                .map((eventName, index) => (
                  <Area
                    key={eventName}
                    type="monotone"
                    dataKey={eventName}
                    stackId="1"
                    stroke={COLORS[index % COLORS.length]}
                    fill={COLORS[index % COLORS.length]}
                    strokeWidth={2}
                  />
                ))}
            </AreaChart>
          </ResponsiveContainer>
        )}
      </Card.Body>
    </Card>
  );
};

export default ActivityCard;
